import CommentsContent from "src/components/NewComponents/Exam/OptionDetails/Comments/CommentsContent";
import {
	useAddComment,
	useRemoveComment,
	useToggleCommentLike,
} from "src/hooks/useComments";

export function QuestionCommentsSection({ question, ...props }) {
	const { mutateAsync: addComment } = useAddComment();
	const { mutateAsync: removeComment } = useRemoveComment();
	const { mutateAsync: toggleLike } = useToggleCommentLike();

	const onAddComment = async (values) => {
		await addComment({
			...values,
			id: question.id,
			question,
		});
	};

	const onToggleLike = async (values) => {
		await toggleLike({
			...values,
			questionId: question.id,
		});
	};

	const onRemoveComment = async (params) => {
		await removeComment({
			...params,
			questionId: question.id,
		});
	};

	return (
		<CommentsContent
			{...props}
			onAddComment={onAddComment}
			onRemoveComment={onRemoveComment}
			onToggleLike={onToggleLike}
		/>
	);
}
